// LivestreamOverlayCta.js
'use strict';
import { connect } from 'react-redux';

import {
  FEATURE_DISPLAY_NAME,
  LIVESTREAM_PAY_DURATION_SECONDS,
  LIVESTREAM_VIEWERS_MAX,
  LIVESTREAM_VIEWERS_MIN,
} from '../RemoteConfigKeys.js';

import LivestreamOverlayCta from '../component/LivestreamOverlayCta.jsx';

import getMeData from '../selector/getMeData.js';
import getPrivateShowStatus from '../selector/getPrivateShowStatus.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getUserData from '../selector/getUserData.js';
import getLiveStreamPrice, {
  getLiveStreamExclusivePrivatePrice,
} from '../selector/getLiveStreamPrice.js';
import getMeBalance from '../selector/getMeBalance.js';
import getListData from '../selector/getListData.js';

import toggleModal from '../action/toggleModal.js';
import addvalue from '../action/addvalue.js';
import unlockPrivateStream from '../action/unlockPrivateStream.js';

import {
  liveStreamSessionLeaderboardCategory,
  livestreamNoticeType,
  PRESET_SD,
} from '../resource/liveStreamConstants.js';

const mapStateToProps = (state, { streamId }) => {
  const sessionId = getLiveStreamData(state, [streamId], 'sessionId');
  const viewers = getLiveStreamData(
    state,
    [streamId, 'presets', PRESET_SD],
    'viewers'
  );
  const username = getUserData(state, streamId, 'username');
  const displayName = getUserData(state, streamId, 'displayName');
  const balance = getMeBalance(state);
  const price = getLiveStreamPrice(state, streamId, PRESET_SD);
  const priceDurationMinutes =
    getRemoteConfigData(state, LIVESTREAM_PAY_DURATION_SECONDS) / 60;
  const viewersMax = getRemoteConfigData(state, LIVESTREAM_VIEWERS_MAX);
  const viewersMin = getRemoteConfigData(state, LIVESTREAM_VIEWERS_MIN);
  const isDisplayNameEnabled =
    getRemoteConfigData(state, FEATURE_DISPLAY_NAME) === 1;
  const leaderboardUserIds = getListData(
    state,
    [
      'liveStream',
      streamId,
      'session',
      sessionId,
      'leaderboard',
      liveStreamSessionLeaderboardCategory.TOTAL,
    ],
    'itemIds'
  );
  const ticketNoticeIds = getListData(
    state,
    ['liveStream', streamId, livestreamNoticeType.TICKET_NOTICE],
    'itemIds'
  );
  return {
    meId: getMeData(state, 'id'),
    username,
    displayName,
    balance,
    viewers,
    price,
    exclusivePrice: getLiveStreamExclusivePrivatePrice(state, streamId),
    priceDurationMinutes,
    viewersMax,
    viewersMin,
    isDisplayNameEnabled,
    leaderboardUserIds,
    ticketNoticeIds,
    streamTitle: getLiveStreamData(state, [streamId], 'title'),
    privateShowStatus: getPrivateShowStatus(state, streamId),
    exclusivePrivateStatus: getLiveStreamData(
      state,
      [streamId, 'exclusivePrivate'],
      'status'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleModal: payload => dispatch(toggleModal(payload)),
    addvalue: () => dispatch(addvalue({ via: 'unlock-livestream' })),
    unlockPrivateStream: data => dispatch(unlockPrivateStream(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LivestreamOverlayCta);
